import './App.css';
import './css/main.css';
import React, { useEffect, useState } from 'react';
import { HashRouter as Router, Routes, Route, useLocation, useNavigate  } from 'react-router-dom';
import Page1 from './components/module1/Page1';
import Lesson from './components/Lesson';
// import Lesson3 from './components/Lesson3';
import HomePage from './components/HomePage';
import Menu from './components/Menu';
import scormAPI from './scorm';
import ScrollToTop from './components/ScrollToTop';

function App() {
  // INICIALIZA O SCORM
  useEffect(() => {
    scormAPI.initializeWithDefaults();
  }, []);

  // VARIÁVEIS DE CONTROLE DO LAYOUT DO SCORM
  const home = true; // define se o scorm vai ter uma HOME ou se já vai inicializar no conteúdo.
  const [menu, setMenu] = useState(false); // define se o scorm vai ter um MENU Lateral.
  const menuNav = false; // define se o scorm vai ter um MENU no Topo.
  const modoExibicao = 'pagination'; // 'pagination' ou 'scroll'

  const location = useLocation();
  const isHomeRoute = location.pathname === '/';

  const menuClass = menuNav ? 'menuNav' : menu ? 'menuVisible' : 'menuHidden';
  const conteudoClass = menuNav ? 'conteudoWithMenuNav' : menu ? 'conteudoWithMenu' : 'conteudoFull';
  const containerClass = menuNav ? 'containerColumn' : 'containerRow';

  const currentConteudoClass = home && isHomeRoute ? 'conteudoFull' : conteudoClass; //Se for rota "/" e home === true, força layout como conteudoFull

  const closeMenu = () => {
    setMenu(false);
  };

    const navigate = useNavigate();

    const handleHome = () => {
      navigate('/'); // Caminho da rota
    };

  return (
    <div className={containerClass}>
      {(!isHomeRoute || !home) && (menu || menuNav) && (
        <div className={`menu ${menuClass}`}>
          <Menu isMenuNav={menuNav} onFechar={closeMenu} />
        </div>
      )}

      <div id="main-scroll" className={`conteudo ${currentConteudoClass}`}>
        { !menu && !(isHomeRoute && home) && (
          <button className='btn-menu' onClick={() => setMenu(prev => !prev)}></button>
        )}
        {  !(isHomeRoute && home) && (
          <button className='btn-home' onClick={handleHome}></button>
        )}

        <ScrollToTop />

        <Routes>
          {home && <Route path="/" element={<HomePage />} />}
          <Route path="/lesson" element={<Lesson className="page" navigationMode={modoExibicao} />} />
          {/* <Route path="/lesson2" element={<Lesson2 className="page" navigationMode={modoExibicao} />} />
          <Route path="/lesson3" element={<Lesson3 className="page" navigationMode={modoExibicao} />} /> */}
        </Routes>
      </div>
    </div>
  );
}

export default function AppWrapper() {
  return (
    <Router>
      <App />
    </Router>
  );
}
